import { RootState } from '../../store';

export const getActiveTicketsByAddressSelector = (state: RootState) => state.ticketReducer.activeTicketsByAddress;
export const getActiveTicketsByAddressLoadingSelector = (state: RootState) => state.ticketReducer.activeTicketsByAddressLoading;
